import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LiftDetail } from '../../models/lift-detail.model';
import { LoginService } from '../../../user/services/login.service';
import { MqttService, IMqttMessage } from 'ngx-mqtt';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-lift-controller',
  templateUrl: './lift-controller.component.html',
  styleUrls: ['./lift-controller.component.css']
})
export class LiftControllerComponent implements OnInit {
  liftId: number;
  lift: LiftDetail;
  menu = 'controller';
  descriptionMessage = "";
  result = "";
  selectedFloor: number = 0;
  selectedCalls: string = "car";
  calls = [
    { 'val': 'car', 'title': 'Kabinová' },
    { 'val': 'floor_up', 'title': 'Staniční nahoru' },
    { 'val': 'floor_dn', 'title': 'Staniční dolu' }
  ];
  floors: number[] = [];

  private subscription: Subscription;

  //Permissions
  canViewErrors: boolean = false;
  canView: boolean = false;
  canControl: boolean = false;
  canViewParameter: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService,
    private mqttService: MqttService
  ) { }

  ngOnInit() {
    this.liftId = +this.route.snapshot.paramMap.get('id');
    const response = this.route.snapshot.data.state;
    this.lift = this.route.snapshot.data.lift;
    let liftPermission = this.route.snapshot.data.liftPermission;
    if (!liftPermission) {
      liftPermission = [];
    }

    this.canViewErrors = liftPermission.indexOf('2') > -1 || this.loginService.isSuperadmin();
    this.canView = liftPermission.indexOf('0') > -1 || this.loginService.isSuperadmin();
    this.canControl = liftPermission.indexOf('3') > -1 || this.loginService.isSuperadmin();
    this.canViewParameter = liftPermission.indexOf('4') > -1 || this.loginService.isSuperadmin();

    for (var i = 0; i <= this.lift.floorCount; i++) {
      this.floors.push(i);
    }

    this.subscription = this.mqttService.observe('/response/module/' + this.lift.liftModule.code + '/lift').subscribe((message: IMqttMessage) => {
      const obj = JSON.parse(message.payload.toString());

      console.log(obj);

      if (obj.index == 5) {
        let device = "";
        let firmware = "";
        let releaseDate = "";

        try {
          device = obj.data.result.Device;
          firmware = obj.data.result.Firmware;
          releaseDate = obj.data.result.ReleaseDate;
        } catch (e) {
          device = "";
          firmware = "";
          releaseDate = "";
        }

        this.descriptionMessage = `
Device: ${device},
Firmware: ${firmware},
ReleaseDate: ${releaseDate}
        `;
      }

      if (obj.index == 2) {
        if (obj.hasOwnProperty("data") && obj.data.hasOwnProperty("result")) {
          this.result = obj.data.result;
        }

        if (obj.hasOwnProperty("data") && obj.data.hasOwnProperty("error")) {
          this.result = 'Chyba:' + String(obj.data.error);
        }
      }
      
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  showCardDescription() {
    const obj = {
      "type": 1,
      "index": 5,
      "data": {
        "cmd": 6
      }
    };
    const message = JSON.stringify(obj);
    this.mqttService.unsafePublish('/request/module/' + this.lift.liftModule.code + '/lift', message); 
  }

  resetBoard() {
    const obj = {
      "type": 1,
      "index": 2,
      "data": {
        "cmd": 0
      }
    };

    const message = JSON.stringify(obj);
    this.mqttService.unsafePublish('/request/module/' + this.lift.liftModule.code + '/lift', message); 
  }

  unblockBoard() {
    const obj = {
      "type": 1,
      "index": 2,
      "data": {
        "cmd": 1
      }
    };

    const message = JSON.stringify(obj);
    this.mqttService.unsafePublish('/request/module/' + this.lift.liftModule.code + '/lift', message);
  }

  clearBoard() {
    const obj = {
      "type": 1,
      "index": 2,
      "data": {
        "cmd": 2
      }
    };

    const message = JSON.stringify(obj);
    this.mqttService.unsafePublish('/request/module/' + this.lift.liftModule.code + '/lift', message);
  }

  setFloor() {
    let args = {};
    args[this.selectedCalls] = (1 << this.selectedFloor);

    const obj = {
      "type": 1,
      "index": 2,
      "data": {
        "cmd": 2,
        "args": args
      }
    };

    const message = JSON.stringify(obj);
    this.mqttService.unsafePublish('/request/module/' + this.lift.liftModule.code + '/lift', message);
  }
}
